module.exports = __webpack_public_path__ + "img/HeimwehScreenshot10.510269ec.png";